export interface DailySummary {
  totalSales: number;
  salesCount: number;
  cashSales: number;
  cardSales: number;
  yapePlinSales: number;
  appSales: number;
  openingAmount: number;
  expenses: DailyExpense[];
  date: string;
  shift: string;
  currentShift?: string;
  locationId: string;
  cancelledSalesAmount?: number;
  cancelledVouchersCount?: number;
}

export interface DailyExpense {
  id: string;
  description: string;
  amount: number;
  category: 'ingredients' | 'services' | 'others' | 'income';
  type: 'expense' | 'income';
  createdAt: string;
}

export interface CashCount {
  bills: Record<string, number>;
  coins: Record<string, number>;
  totalCounted: number;
  isSaved?: boolean;
}

export interface FinalBalance {
  expectedCash: number;
  countedCash: number;
  difference: number;
  canClose: boolean;
}

export interface CashRegisterState {
  dailySummary: DailySummary | null;
  expenses: DailyExpense[];
  cashCount: CashCount;
  finalBalance: FinalBalance | null;
  isExpenseModalOpen: boolean;
  isIncomeModalOpen: boolean;
  loading: boolean;
  isOpened: boolean;
  openingAmount: number;
  currentShift?: string;
  actualShift?: string;
  shiftSchedule?: any;
}

export interface CreateExpenseData {
  description: string;
  amount: number;
  category: 'ingredients' | 'services' | 'others' | 'income';
  type: 'expense' | 'income';
  locationId: string;
}

export interface CloseCashRegisterData {
  locationId: string;
  date: string;
  cashCount: CashCount;
  finalBalance: FinalBalance;
}

export interface OpenCashRegisterData {
  locationId: string;
  date: string;
  openingAmount: number;
  shift?: string; // Opcional, se calcula automáticamente desde el backend
}

export interface ShiftStatus {
  isOpened: boolean;
  currentShift: string;
  actualShift?: string;
  shiftSchedule?: any;
}

export interface ShiftSummary {
  shift: string;
  isOpen: boolean;
  totalSales: number;
  salesCount: number;
  openingAmount: number;
  openedAt?: string;
  closedAt?: string;
  expensesCount: number;
}

export interface AllShiftsData {
  date: string;
  locationId: string;
  shifts: ShiftSummary[];
}

export const BILL_DENOMINATIONS = [200, 100, 50, 20, 10] as const;
export const COIN_DENOMINATIONS = [5, 2, 1, 0.5, 0.2, 0.1] as const;

export type BillDenomination = typeof BILL_DENOMINATIONS[number];
export type CoinDenomination = typeof COIN_DENOMINATIONS[number];